<template>
  <div>
    <canvas id="bar-chart-user-active" height="400"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "BarChartUserActive",
  props: {
    data: {
      type: Array,
      require: true,
    },
    yAxisTitle: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        parsing: {
          xAxisKey: "monthName",
          yAxisKey: "count",
        },
        layout: {
          padding: 0,
        },
        scales: {
          y: {
            ticks: {
              beginAtZero: true,
            },
            title: {
              display: true,
              align: "center",
              text: "จำนวนผู้ใช้งาน(คน)",
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
          x: {
            beginAtZero: true,
            title: {
              display: true,
              align: "center",
              text: this.yAxisTitle,
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            bodyAlign: "center",
            yAlign: "bottom",
            titleColor: "#575757",
            backgroundColor: "#F1F1F1",
            titleMarginBottom: 0,
            padding: 12,
            callbacks: {
              title: function(context) {
                const contextElement = context[0];
                const index = contextElement.dataIndex;
                const label = "จำนวนผู้ใช้งาน";
                const value = contextElement.dataset.data[index];
                const valueFomrat = value.countFormat
                const back = "คน";
                return `${label} ${valueFomrat} ${back}`;
              },
              label: function(context) {
                return;
              },
              afterLabel: function(context) {
                return;
              },
            },
          },
        },
      },
    };
  },
  mounted() {
    const ctx = document.getElementById("bar-chart-user-active").getContext("2d");
    new Chart(ctx, {
      type: "bar",
      data: {
        datasets: [
          {
            backgroundColor: "#8F20C6",
            barPercentage: 0.4,
            data: this.data,
            borderRadius: {
              bottomLeft: 0,
              bottomRight: 0,
              topLeft: 10,
              topRight: 10,
            },
          },
        ],
      },
      options: this.options,
    });
  },
};
</script>
